const SignupConstants = {
	SIGNUP_REQUEST: 'SIGNUP_REQUEST',
	SIGNUP_SUCCESS: 'SIGNUP_SUCCESS',
	SIGNUP_FAILURE: 'SIGNUP_FAILURE',
}

export default SignupConstants;
